/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { number, object, string } from "yup";
import { CreditCashReq } from "src/interfaces/Deposit";
import { Wrapper } from "src/components/Wrapper/styled";
import { Layout } from "src/components/Layout";
import { Details } from "./Details";

import { userInterface } from "src/interfaces/Client";
import {
  Button,
  Deposit,
  FDeposit,
  Icon,
  Input,
  Radio,
  Select,
} from "src/components";
import { Col, message, Row } from "antd";
import { PlusSignCircleIcon } from "@hugeicons/core-free-icons";
import HugeIcon from "src/components/HugeIcon";
import { DASHBOARD } from "src/utils/constants/routes";
import { useHistory } from "react-router-dom";
import ArrowCircleright from "src/assets/ArrowCircleright.svg";
import { ButtonContainer } from "src/pages/LeanDeposit/Details/styles/styleCardSummaryInfo";
import {
  getcustomerId,
  creatPayment,
} from "src/pages/LeanDeposit/tools/leanDepositFunctions";
import { Pay } from "src/pages/LeanDeposit/tools/leanFunctions.js";
import { getPaymentDestinationDetails } from "src/pages/LeanDeposit/tools/callRequest";
import { feedback, isUuid } from "src/pages/LeanDeposit/tools/helper";
import { DepositSummary } from "src/pages/LeanDeposit/form/depositSummary";
import { DoneModal } from "src/pages/LeanDeposit/Modals/done";
import { Adddeposit } from "src/action";
import { useWindowSize } from "src/hooks/useWindowSize";
import { formatAmount } from "src/utils/number";
import {
  NewBankAccount,
  getClientBankAccounts,
} from "src/components/NewBankAccount";
import { useGetLeanCustomerSourcesQuery } from "src/store/bankAccounts/api";
import axiosInstance from "src/utils/axiosInstanceV2";
import styled from "styled-components";
import { ManualBankModel } from "./ManualBank";
import { antd_breakingPts } from "src/utils/constants/media";
import { useMediaQuery } from "src/hooks/useMediaQuery";
import { colors } from "src/theme/colors";
import { line, radii, space } from "src/theme/ui";
import PageHeader from "src/components/PageHeader";
import { Button as UIButton, DialogFooter } from "src/components/ui";
import {
  AccountField,
  AccountRow,
} from "src/components/Modals/CashFlows/AccountRow";

/**
 * How the money gets here: a choice of two, as two option cards.
 *
 * They were two divs with a 2px accent border each — the same 2px whether
 * chosen or not — one of them filled with a hard-coded #E8F1FF, holding a
 * bare radio with no label beside a separate 10px block of black text. Three
 * consequences: both cards read as selected because both had the heavy edge;
 * ten-pixel copy is below this product's smallest legible size; and because
 * the text was not the radio's label, clicking the words that describe an
 * option did not choose it.
 *
 * Now each card IS a label, so the whole tile is the hit area, and only the
 * chosen one takes the accent. The disabled one says why it is disabled
 * instead of leaving the reader to infer it from the fine print.
 */
/* A flex ITEM in the app's content row, so it has to be told to take the
   row: at its default `flex: 0 1 auto` a width of 100% resolves against its
   own content, and these pages were rendering in a 540px column with four
   hundred pixels of the window unused beside them. */
/* In a dialog the form takes the dialog's own measure. The 560px cap on the
   form column is for a PAGE, where a form the width of a wide window is
   unreadable; a dialog is already that measure, and the cap left the footer
   band thirty pixels short of the dialog's edges. */
const DialogBody = styled.div`
  width: 100%;
`;

const Page = styled.div`
  flex: 1;
  width: 100%;
  min-width: 0;
`;

/* The form's rows. The account row itself is shared with the withdraw
   dialog — see components/Modals/CashFlows/AccountRow. */
const FieldStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const OptionCard = styled.div<{ $on: boolean; $disabled?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  min-width: 0;
  padding: 12px;
  border: 1px solid ${({ $on }) => ($on ? colors.primary[300] : line.field)};
  border-radius: ${radii.lg}px;
  background: ${({ $on }) => ($on ? colors.primary[15] : colors.white)};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: ${({ $on, $disabled }) =>
      $disabled ? line.field : $on ? colors.primary[400] : colors.gray[300]};
  }

  /* The dial sits next to the words it selects, at the card's own gap.
     Sixty-two pixels of it were the RADIO's: the shared radio carries a 36px
     right margin for the row of radios it was written for, and antd puts an
     empty 16px label span after the dial — which this card does not use,
     because the card itself is the label. */
  .ant-radio-wrapper {
    margin-right: 0;
  }

  .ant-radio-wrapper > span:not(.ant-radio) {
    display: none;
  }
`;

const OptionBody = styled.div`
  min-width: 0;
`;

const OptionName = styled.span`
  display: block;
  margin-bottom: 2px;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.gray[900]};
`;

const ContentCard = styled.span`
  display: block;
  font-size: 12px;
  line-height: 1.5;
  color: ${colors.gray[600]};
`;

type DepostProps = {
  user: userInterface;
  /**
   * Rendered inside a dialog rather than as a page.
   *
   * The flow is identical either way — the same two steps, the same
   * handlers, the same validation. What changes is only the chrome: a dialog
   * already carries a title and a scrim, so the page header, the page-width
   * card and the two-column layout all come off, and the balance summary
   * moves from a panel beside the form to a strip above it.
   */
  asDialog?: boolean;
  /** How the dialog closes, in place of navigating to the dashboard. */
  onClose?: () => void;
};

enum DESTINATION_BANKS {
  SBNYUSD = 0,
  ADIBUSD = 1,
  ADIBAED = 2,
}

const minimumDeposit = { lean: 2000, manual: 5000 };
const maximumDeposit = { lean: 2000, manual: Number.MAX_SAFE_INTEGER };
// payment intent will be created only if the amount is less than 10,700USD; 40000 AED
// SDK show the amount in 10,000USD
const MAX_DEPOSIT_VALUE = 270000;

/* Either the dialog's foot or nothing at all — a page renders the pair in
   its own flow, which is what the fragment does. */
const Slot: React.FC<{ asDialog?: boolean; children: React.ReactNode }> = ({
  asDialog,
  children,
}) => (asDialog ? <DialogFooter>{children}</DialogFooter> : <>{children}</>);

const DepositPage: React.FC<DepostProps> = ({ user, asDialog, onClose }) => {
  const client = user?.data;
  const history = useHistory();
  const [visible, setVisible] = useState({
    visibleDrawer: false,
    visibleBankModal: false,
  });
  const [step, setStep] = useState(0);
  const [disableButton, setDisableButton] = useState(true);
  const [nondisabled, setNonDisabled] = useState(false);
  const [customerId, setCustumerId] = useState(null);
  const [paymentDestinationId, setPaymentDestinationId] = useState(null);
  const [paymentDestination, setPaymentDestination] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState("USD");
  const [isBank, setIsBank] = useState(false);
  const [clientBankAccounts, setClientBankAccounts] = useState([]);
  /* An empty list means "none on file" only once the fetch has answered;
     before that it means "not yet known", and the two must not look alike. */
  const [banksLoaded, setBanksLoaded] = useState(false);
  const { width } = useWindowSize();
  const [bankType, setBankType] = useState("Manually");
  const { data: leanCustomerSources } = useGetLeanCustomerSourcesQuery(0);
  const [selectedOption, setSelectedOption] = useState("Manually");
  const [error, setError] = useState("");
  const [minDeposit, setMinDeposit] = useState(minimumDeposit.manual);
  const [maxDeposit, setMaxDeposit] = useState(maximumDeposit.manual);

  const isMobile = useMediaQuery("(max-width: 576px)");

  /* Instant top-up needs a linked source that is actually live. Read once
     rather than repeated inline, and used to say WHY the option is off. */
  const leanDisabled = !leanCustomerSources?.some(
    (item) => item.status === "ACTIVE",
  );

  const getMinimumDeposit = (isLean) =>
    isLean ? minimumDeposit.lean : minimumDeposit.manual;

  const formik = useFormik({
    initialValues: {
      amount: minDeposit,
      transferReferNumber: "",
      origin: undefined,
      finamazeBankAccount: "New York Bank",
    },
    onSubmit: async (values) => {
      setLoading(true);
      const res = await Adddeposit(values);
      if (res.success) {
        setStep(2);
      } else {
        setError(res?.message);
      }
      setLoading(false);
    },
    validationSchema: object().shape<CreditCashReq | any>({
      /* Messages a reader can act on. "Must be a number" describes the
         library's cast rather than the mistake, "required" is not a
         sentence, and the ceiling read "Must be less than
         9,007,199,254,740,991 USD" wherever no real ceiling applies. */
      amount: number()
        .transform((value) => (Number.isNaN(value) ? undefined : value))
        .typeError("Enter the amount in figures")
        .min(
          minDeposit,
          `The smallest deposit is ${currency} ${formatAmount(minDeposit)}`,
        )
        .max(
          maxDeposit,
          maxDeposit >= Number.MAX_SAFE_INTEGER
            ? "That is more than can be transferred at once"
            : `The largest deposit is ${currency} ${formatAmount(maxDeposit)}`,
        )
        .when("origin", {
          is: (val: string) => isUuid(val),
          then: (schema) =>
            schema.max(
              MAX_DEPOSIT_VALUE,
              `You may transfer a maximum amount of ${formatAmount(
                MAX_DEPOSIT_VALUE,
              )} USD in a single wire transfer.`,
            ),
        })
        .required("Enter the amount you want to deposit"),
      transferReferNumber: string(),
      origin: string().required("Choose the account you are sending from"),
      finamazeBankAccount: string()
        .oneOf(["Abu Dhabi Bank", "New York Bank"])
        .required("Choose which FinaMaze account to credit"),
    }),
  });

  const onSelectionChange = (value, name) => {
    formik.setFieldValue(name, value);
  };

  const getDetail = async (clientId) => {
    const temp = await getcustomerId(clientId);
    setCustumerId(temp);
  };

  const paymentDestinationDetails = async () => {
    try {
      const temp = await getPaymentDestinationDetails();
      setPaymentDestination(temp);
      setPaymentDestinationId(temp[0]?.id);
    } catch (err) {
      err;
    }
  };
  const handlePayResponse = (data) => {
    if (data.status === "SUCCESS") {
      message.success(data.message);
      history.push("/");
    }
  };

  const handlePayLeanIntents = async () => {
    const payload = { amount: formik.values.amount, currency: "USD" };
    try {
      const { data } = await axiosInstance.post(
        "/dashboard/lean/payments/intents",
        payload,
      );

      if (data.payment_intent_id) {
        Pay(data.payment_intent_id, handlePayResponse);
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle any errors here
    }
  };

  const onChange = (e) => {
    setBankType(e.target.value);
  };

  // //getcustomer id
  // useEffect(() => {
  //   // if (!customerId) getDetail(client?._id);
  //   // paymentDestinationDetails();
  // }, []);

  useEffect(() => {
    getClientBankAccounts(client, (accounts) => {
      setClientBankAccounts(accounts);
      setBanksLoaded(true);
    });
  }, [visible]);

  /* No bank on file. Not the same as not having chosen one. */
  const hasNoBankAccount = banksLoaded && clientBankAccounts.length === 0;

  /**
   * The first account, chosen for them — the same thing picking it by hand
   * does, minimum and all.
   *
   * The form opened on an empty select, and until it was answered the amount
   * had no minimum to check against and the Next button stayed off: a
   * required choice, usually of one, standing between the reader and the
   * rest of the form. Never over a choice already made.
   */
  useEffect(() => {
    if (!clientBankAccounts?.length || formik.values.origin) return;
    const first = clientBankAccounts[0];
    const minimum = getMinimumDeposit(first?.isLean);
    setMinDeposit(minimum);
    /* One update, not two. Each `setFieldValue` schedules its own validation
       pass, and the second one's pass ran against a snapshot taken before
       the first had landed — so the form held a chosen account while its
       errors still said "Choose the account you are sending from", and Next
       stayed off under a complete form. */
    formik.setValues({
      ...formik.values,
      origin: first.value,
      amount: minimum,
    });
    setNonDisabled(true);
    setIsBank(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientBankAccounts]);

  /* The form's own body, with no chrome around it — the page and the dialog
     each wrap it in their own. */
  const formBody = (
    <FDeposit leanWrapper={true} $full={asDialog} title="">
      <FDeposit.Text>Choose your bank account</FDeposit.Text>
      <FDeposit.SubText>
        Select the account you want to transfer money from
      </FDeposit.SubText>
      <FDeposit.RadioContainer>
        <Radio.Group
          name="finamazeBankAccount"
          defaultValue="Manually"
          onChange={onChange}
          style={{
            display: "flex",
            flexDirection: width < antd_breakingPts.sm ? "column" : "row",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <OptionCard
            $on={selectedOption === "Manually"}
            role="radio"
            tabIndex={0}
            aria-checked={selectedOption === "Manually"}
            onClick={() => setSelectedOption("Manually")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setSelectedOption("Manually");
              }
            }}
          >
            <Radio
              name=""
              value="Manually"
              checked={selectedOption === "Manually"}
              onChange={() => setSelectedOption("Manually")}
            />
            <OptionBody>
              {/* The product's own wording for each method, kept as it was
                  written. */}
              <OptionName>Manually</OptionName>
              <ContentCard>
                Initiate wire transfers to credit your FinaMaze balance from
                your bank
              </ContentCard>
            </OptionBody>
          </OptionCard>
          <OptionCard
            $on={selectedOption === "Automatically"}
            $disabled={leanDisabled}
            role="radio"
            tabIndex={leanDisabled ? -1 : 0}
            aria-checked={selectedOption === "Automatically"}
            aria-disabled={leanDisabled}
            onClick={() => {
              if (!leanDisabled) setSelectedOption("Automatically");
            }}
            onKeyDown={(e) => {
              if (!leanDisabled && (e.key === "Enter" || e.key === " ")) {
                e.preventDefault();
                setSelectedOption("Automatically");
              }
            }}
          >
            <Radio
              name=""
              value="Automatically"
              checked={selectedOption === "Automatically"}
              onChange={() => setSelectedOption("Automatically")}
              disabled={leanDisabled}
            />
            <OptionBody>
              {/* Switched off for now, but what it offers has not changed, so
                  the message it has always carried stays. */}
              <OptionName>Automatically with LEAN</OptionName>
              <ContentCard>
                Unlock instant top-ups with LEAN (UAE &amp; KSA only)
              </ContentCard>
            </OptionBody>
          </OptionCard>
        </Radio.Group>
      </FDeposit.RadioContainer>

      <FDeposit.FormItem>
        <FieldStack>
          {bankType === "Manually" && (
            <AccountRow>
              <AccountField>
                <Select
                  label="Your Bank Account"
                  required
                  /* With nothing on file the field says so itself, greyed
                     out. There is no choice to make and nothing the reader
                     did wrong, so there is nothing to put in red. */
                  placeholder={
                    hasNoBankAccount
                      ? "No bank account yet"
                      : "Select your bank account"
                  }
                  /* Through the helper, which waits for a touch. Read straight
                     off formik.errors, this went red before the reader had
                     done anything — and with no account on file there is
                     nothing to choose, so the note below says that instead. */
                  error={hasNoBankAccount ? undefined : feedback(formik, "origin")}
                  onBlur={() => {
                    formik.setFieldTouched("origin", true);
                  }}
                  name="origin"
                  id="origin"
                  onSelectionChange={async (value, name) => {
                    const bank = clientBankAccounts.find(
                      (elm) => elm.value === value,
                    );
                    const minDeposit = getMinimumDeposit(bank?.isLean);
                    setMinDeposit(minDeposit);

                    await formik.setFieldValue("origin", value);
                    await formik.setFieldValue("amount", minDeposit);

                    setNonDisabled(true);
                    setIsBank(true);
                  }}
                  value={formik.values.origin}
                  size="large"
                  items={clientBankAccounts}
                  disabled={hasNoBankAccount}
                />
              </AccountField>

              <FDeposit.AddLink
                icon={<HugeIcon icon={PlusSignCircleIcon} />}
                onClick={() =>
                  setVisible({ ...visible, visibleBankModal: true })
                }
              >
                New Bank Account
              </FDeposit.AddLink>
            </AccountRow>
          )}
          <div>
            <Input.InputNumber
              key={currency}
              id="amount"
              name="amount"
              required
              error={feedback(formik, "amount")}
              formatter={(value) =>
                `${currency} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/[USD|AED]\s?|(,*)/g, "")}
              precision={0}
              placeholder="20,000"
              label="Amount"
              onBlur={() => {
                formik.setFieldTouched("amount", true);
              }}
              value={formik.values.amount}
              onChange={(value) => {
                onSelectionChange(value, "amount");

                (value as number) < minDeposit
                  ? setNonDisabled(false)
                  : setNonDisabled(true);
              }}
            />
          </div>
        </FieldStack>
        {/* In the dialog the pair goes to the shell's FOOT, from here — the
            flow keeps its own state and the actions still land in the one
            band that cannot scroll. See ui/Modal's DialogFooter. */}
        <Slot asDialog={asDialog}>
          <ButtonContainer $band={false}>
            <UIButton
              variant="secondary"
              size="lg"
              onClick={() => (asDialog ? onClose?.() : history.push(DASHBOARD))}
            >
              Cancel
            </UIButton>
            {bankType === "Automatically" && (
              <UIButton
                variant="primary"
                size="lg"
                disabled={
                  leanCustomerSources?.length && bankType !== "Automatically"
                }
                onClick={handlePayLeanIntents}
              >
                Pay
              </UIButton>
            )}
            {bankType !== "Automatically" && (
              <UIButton
                variant="primary"
                size="lg"
                /* Not `dirty`. That stood in for "the reader has typed
                 something", which stopped being the right question once the
                 form arrives with the first account chosen and the minimum
                 filled in: the dialog opened complete and valid with Next
                 switched off until you retyped a figure that was already
                 correct. What has to hold is what the other three say — an
                 account chosen, an amount at or above its minimum, and
                 nothing invalid. */
                disabled={!formik.isValid || !nondisabled || !isBank}
                onClick={() => {
                  if (isUuid(formik?.values?.origin)) {
                    const submit = {
                      amount: Math.floor(formik?.values?.amount),
                      customerId: customerId,
                      currency: currency,
                      provider: "leantech",
                      paymentDestinationId: paymentDestinationId,
                    };
                    creatPayment(submit, (res) => {
                      if (res.status === "SUCCESS") {
                        setStep(2);
                      } else setNonDisabled(true);
                    });
                  } else {
                    setStep(1);
                  }
                }}
              >
                Next
              </UIButton>
            )}
          </ButtonContainer>
        </Slot>
      </FDeposit.FormItem>
    </FDeposit>
  );

  const balanceStrip = (asDialog?: boolean) => (
    <Details
      deposit={Math.floor(formik?.values?.amount)}
      current={Math.floor(client?.balance)}
      asDialog={asDialog}
    />
  );

  const RenderComponent = [
    <React.Fragment key={"0"}>
      {asDialog ? (
        <DialogBody>
          {balanceStrip(true)}
          {formBody}
        </DialogBody>
      ) : (
        /* One block, not two flex items: the app's content shell is a flex
           row, so a header added as a sibling of the layout made the layout a
           flex item beside it and both shrank to their content. */
        <Page>
          <PageHeader
            name="Deposit cash"
            lead="Move money from your bank into your FinaMaze balance."
          />
          <Layout isMobile={isMobile} customDetail={() => balanceStrip()}>
            <Wrapper>{formBody}</Wrapper>
          </Layout>
        </Page>
      )}
      <ManualBankModel
        onCancel={() => {
          setVisible({ ...visible, visibleBankModal: false });
        }}
        key={visible.visibleBankModal.toString()}
        visible={visible.visibleBankModal}
        client={client}
      />
    </React.Fragment>,
    <DepositSummary
      key={"1"}
      client={client}
      formik={formik}
      loading={loading}
      status={"Pending"}
      history={history}
      asDialog={asDialog}
      onCancel={() => setStep(0)}
    />,
    <DoneModal key={"2"} history={history} asDialog={asDialog} onClose={onClose} />,
  ];
  return <>{RenderComponent[step]}</>;
};
export default DepositPage;
